/**
 * Container Stack Position Formatter.
 */
window.containerStackPositionFormatter = function(value, row) {
    return '<a href="/container-stack-positions/show/'+row.terminal_id+'">'+row.terminal+'</a>';
};
